import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Drawer = styled(motion.div)`
    padding: ${({ theme }) => theme.base.spacing[6]} ${({ theme }) => theme.base.spacing[4]};
    padding-bottom: ${({ theme }) => theme.base.spacing[8]};
    background-color: ${({ theme }) => theme.base.color.backgroundMain};
    border-radius: ${({ theme }) => theme.base.radius.md} ${({ theme }) => theme.base.radius.md} 0 0;
    min-height: 10px;
    width: 100%;
    bottom: 0px;
    position: absolute;
`;
